module.exports = __webpack_public_path__ + "img/arteria.1f7bc268.jpg";